import { inject } from "@angular/core";
import { CanActivateFn, Router } from "@angular/router";

export const WorkInProgressGuard: CanActivateFn = () => inject(Router).createUrlTree(["/help/coming-soon"]);
